/* Fit Shopify's native installment banner to one line without changing its text,
 * markup, logo, information button, or event listeners. Keep the normal font
 * size wherever it fits; scale only the banner text when space is limited.
 */
if (document.querySelector('[data-pdp-shipping-context]')) {
  const attached = new WeakSet();
  const attach = host => {
    if (attached.has(host) || !host.shadowRoot) return;
    attached.add(host);
    const root = host.shadowRoot;
    const fit = () => {
      const paragraph = root.querySelector('#shopify-installments');
      if (!paragraph || !root.querySelector('#shopify-installments-cta')) return;
      let style = root.querySelector('[data-hop-installments-wrap]');
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-hop-installments-wrap', '');
        style.textContent = ':host{display:block;min-width:0}#shopify-installments{white-space:nowrap}';
        root.append(style);
      }
      const rule = style.sheet?.cssRules[1];
      if (!rule) return;
      const base = parseFloat(getComputedStyle(host).fontSize);
      if (!Number.isFinite(base)) return;
      let size = base;
      rule.style.fontSize = size + 'px';
      const width = paragraph.getBoundingClientRect().width;
      if (!width) return;
      for (let attempt = 0; attempt < 8 && paragraph.scrollWidth > width; attempt++) {
        size *= width / paragraph.scrollWidth;
        rule.style.fontSize = size + 'px';
      }
    };
    new MutationObserver(fit).observe(root, {childList:true,subtree:true,characterData:true});
    let observedWidth = -1;
    let pendingFrame = 0;
    new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (width === observedWidth) return;
      observedWidth = width;
      if (pendingFrame) cancelAnimationFrame(pendingFrame);
      pendingFrame = requestAnimationFrame(() => { pendingFrame = 0; fit(); });
    }).observe(host);
    fit();
  };
  customElements.whenDefined('shopify-payment-terms').then(() => {
    const scan = node => {
      if (!(node instanceof Element)) return;
      if (node.matches('shopify-payment-terms')) attach(node);
      node.querySelectorAll('shopify-payment-terms').forEach(attach);
    };
    const main = document.getElementById('MainContent');
    if (!main) return;
    scan(main);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(main, {childList:true,subtree:true});
  });
}
